import {ChangeDetectionStrategy, Component, DestroyRef, inject, OnInit, signal} from '@angular/core';
import {takeUntilDestroyed} from '@angular/core/rxjs-interop';
import {APP_BASE_HREF} from "@angular/common";

import {BaseRequestComponent} from '../base-request-component';
import {GbgRequestService} from './services/gbg-request.service';
import {PortalConfig} from '@shared/portal-config';
import {GbgStepComponent} from '@shared/components/gbg-step/gbg-step.component';
import {ModalService} from '@shared/services/modal.service';
import {ErrorModalComponent} from '@shared/components/error-modal/error-modal.component';
import {STEP_SUBMIT_GENERIC_ERROR} from '@shared/utilities/step-submit-error';

@Component({
    selector: 'app-gbg-request',
    templateUrl: './gbg-request.component.html',
    styleUrls: ['./gbg-request.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [GbgStepComponent]
})
export class GbgRequestComponent extends BaseRequestComponent implements OnInit {

  private readonly destroyRef = inject(DestroyRef);
  private readonly baseHref = inject(APP_BASE_HREF);
  private readonly gbgRequestService = inject(GbgRequestService);
  private readonly portalConfig = inject(PortalConfig);
  private readonly modalService = inject(ModalService);

  readonly nextEnabled = signal(false);
  readonly hasError = signal(false);
  readonly supportMessage = signal('');

  ngOnInit(): void {
    this.supportMessage.set(this.portalConfig.supportMessage);

    if (this.step().completed) {
      this.nextEnabled.set(true);
      return;
    }

    this.hasError.set(true);
    console.warn('GBG SDK not available - feature not yet implemented');
  }

  save(journeyId: string): void {
    this.processing = true;

    this.gbgRequestService.save(this.request().id, this.step().id, journeyId).pipe(
      takeUntilDestroyed(this.destroyRef)
    ).subscribe({
      next: updatedRequest => {
        this.updateRequest(updatedRequest);
        this.processing = false;
        this.nextEnabled.set(true);
      },
      error: () => {
        this.processing = false;
        this.modalService.openModal(ErrorModalComponent, STEP_SUBMIT_GENERIC_ERROR);
      }
    });
  }
}
